<div class="layout" [class.layout--sidebar-collapsed]="sidebarState.isCollapsed()">
  <app-sidebar></app-sidebar>
  <main class="content">
    <div class="content__wrapper">
      <div class="content__inner">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
<app-help-button></app-help-button>
